// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iG4U","right":"styles_right__3sUWQ"};